import React, { useState } from 'react';
import RenderInBody from 'components/shared/render_in_body';
import ModalContainer from 'components/shared/modal/modal_container';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, ButtonGroup, Icon } from 'ui';
import request from 'utils/request_ajax';
import { routes as ROUTES } from 'constants/config';
import { AlertCircle } from 'react-feather';
import * as actions from '../../actions/journeyBuilder';
import { formatDate } from './__helpers__/journeyHelper';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const EditDetails = () => {
  const { title, description, published, journeyStatus } = useSelector(
    state => state,
  );

  const [titleInput, setTitleInput] = useState(title);
  const [descriptionInput, setDescriptionInput] = useState(description);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { journeyId } = useParams();
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(actions.hideEditDetails());
  };

  const handleSubmit = e => {
    e.preventDefault();
    setError(false);
    setLoading(true);

    request
      .patchJSON(ROUTES.JOURNEY.RESOURCE(journeyId), {
        title: titleInput,
        description: descriptionInput,
        published,
        journey_status: journeyStatus,
      })
      .then(responseData => {
        dispatch(
          actions.updateJourneyDetails({
            title: titleInput,
            description: descriptionInput,
          }),
        );
        dispatch(
          actions.updateJourneyStatus({
            journeyStatus: responseData.journeyStatus,
          }),
        );
        dispatch(
          actions.updateAutosavedAt({
            autosavedAt: formatDate(responseData.updatedAt),
          }),
        );
        dispatch(actions.hideEditDetails());
      })
      .fail(err => {
        console.error(err);
        setError(true);
        setLoading(false);
      });
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c JourneyEditDetailsModal-background"
        onEscape={handleCloseModal}
      >
        <div className="ModalTakeover-container JourneyEditDetailsModal-container">
          <div className="JourneyEditDetailsModal-body">
            <form onSubmit={handleSubmit}>
              <div className="JourneyEditDetailsModal-title">
                {t('journeys.builder.edit_modal.title')}
              </div>
              {error && (
                <div className="JourneyEditDetailsModal-error">
                  <div>
                    <AlertCircle
                      className="JourneyEditDetailsModal-icon"
                      size={18}
                    />
                  </div>
                  <div>{t('journeys.builder.edit_modal.error')}</div>
                </div>
              )}
              <label
                htmlFor="title"
                className="JourneyEditDetailsModal-inputTitle"
              >
                {t('common.title') + ' *'}
              </label>
              <input
                id="title"
                name="title"
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput JourneyEditDetailsModal-input"
                placeholder={t('common.enter_title')}
                type="text"
                onChange={e => setTitleInput(e.target.value)}
                value={titleInput}
                maxLength="255"
              />
              <label
                htmlFor="description"
                className="JourneyEditDetailsModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                className="NewInput NewInput--white NewInput--fw JourneyEditDetailsModal-input"
                placeholder={t('common.enter_description')}
                rows="3"
                onChange={e =>
                  setDescriptionInput(e.target.value.replace(/\r?\n|\r/g, ' '))
                }
                onKeyDown={preventLineBreaks}
                value={descriptionInput}
              />
              <ButtonGroup alignEnd className="mt-32">
                <Button
                  type="primary"
                  disabled={loading}
                  onClick={handleCloseModal}
                >
                  {t('common.cancel')}
                </Button>
                <Button
                  customColor
                  type="submit"
                  loading={loading}
                  disabled={title.length === 0 || loading}
                >
                  {t('common.save')}
                </Button>
              </ButtonGroup>
            </form>
            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={handleCloseModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default EditDetails;
